export default "__VITE_ASSET__$Wi$4saH__"